import colors from 'global/styles/colors'
import PropTypes from 'prop-types'
import React from 'react'

const RequiredLabel = ({ text, required = false, children }) => {
  const labelText = children ?? text ?? ''
  const requiredAsteriskStyle = {
    color: colors.colorDanger,
    marginLeft: 4,
  }

  return (
    <span>
      {labelText}
      {required && <span style={requiredAsteriskStyle}>*</span>}
    </span>
  )
}

RequiredLabel.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
  text: PropTypes.node,
}

export default RequiredLabel
